import { useId } from "react"

interface LandingLogoLockupOutineReverseProps {
  className?: string
  style?: React.CSSProperties
}

export function LandingLogoLockupOutineReverse({ className = "", style }: LandingLogoLockupOutineReverseProps) {
  const clipId = useId()

  return (
    <svg
      viewBox="0 0 511 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-label="Bracket Logo"
    >
      <title>Bracket Logo</title>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M114.97 24.4688H105.14L101.06 39.2388H110.76C117.12 39.2388 120.55 34.7288 120.64 30.2688C120.68 28.5588 120.14 27.0488 119.14 26.0188C118.14 24.9988 116.73 24.4788 114.96 24.4788L114.97 24.4688Z"
          fill="currentColor"
        />
        <path
          d="M57.3601 23.7188H46.7801L43.3201 36.2488H53.8601C58.5701 36.2488 62.1901 33.0388 62.2801 28.7688C62.3101 27.2688 61.8601 25.9888 60.9801 25.0988C60.1001 24.1988 58.8401 23.7188 57.3501 23.7188H57.3601Z"
          fill="currentColor"
        />
        <path
          d="M52.3499 49.4766H39.6699L36.1599 62.1866H48.6599C53.3199 62.1866 56.8999 58.9366 56.9899 54.6166C57.0199 53.0766 56.5399 51.7166 55.6199 50.7866C54.7799 49.9266 53.6499 49.4766 52.3399 49.4766H52.3499Z"
          fill="currentColor"
        />
        <path d="M297.32 69.9634L312.11 16.2734L281.33 44.5034L297.32 69.9634Z" fill="currentColor" />
        <path d="M156.42 49.0384H171.17L170.16 25.1484L156.42 49.0384Z" fill="currentColor" />
        <path
          d="M507.75 15.19H468.17L471.36 3.41C471.82 1.69 470.53 0 468.75 0H16.4801C15.1101 0 13.9101 0.92 13.5501 2.24L5.3401 32.47C5.2001 33 5.3001 33.55 5.6401 33.99C5.9801 34.43 6.4801 34.68 7.0301 34.68H13.4001L0.0801042 83.27C-0.0998958 83.93 0.0301042 84.63 0.450104 85.17C0.870104 85.72 1.5001 86.03 2.1901 86.03H447.56C448.99 86.03 450.25 85.07 450.63 83.69L453.75 73.3H493.13C494.56 73.3 495.82 72.34 496.2 70.96L510.37 18.6C510.84 16.88 509.54 15.18 507.76 15.18L507.75 15.19ZM66.9901 69.76C62.3001 73.65 55.8601 75.8 48.8501 75.8H14.6601L28.8001 24.44H20.5201L20.5501 24.33L24.4401 10.29H62.6601C68.6501 10.29 73.4301 11.94 76.4901 15.07C78.9901 17.62 80.2601 21.13 80.1701 25.22C80.0801 29.36 78.5601 33.43 75.8801 36.69C73.2701 39.87 69.7801 41.99 66.0301 42.69C71.5101 44.45 74.4501 48.81 74.3201 54.99C74.2001 60.67 71.5901 65.92 66.9801 69.75L66.9901 69.76ZM172.34 75.8V75.72L171.74 62.75H148.53L140.78 75.8H111.17H111.1V75.73L106.32 53.21H97.0801L90.8501 75.79H72.6501L72.6801 75.68L90.6901 10.3H117.34C125.77 10.3 132.22 12.64 135.99 17.07C138.98 20.58 140.17 25.35 139.34 30.49C138.59 35.16 136.47 39.36 133.06 42.95C130.34 45.82 126.85 48.18 123.25 49.6L127.54 66.93L162 10.31H186V10.39L190.72 75.81H172.33L172.34 75.8ZM218.34 75.8C215.12 75.8 204.08 75.15 197.29 66.8C192.27 60.62 190.9 51.87 193.23 40.79C195.96 27.76 200.91 19.19 208.36 14.58C214.76 10.62 221.96 10.29 228.2 10.29H254.31L250.22 25.16H230.04C220.08 25.16 215.48 29.26 212.47 40.83C210.4 48.8 210.6 54.24 213.09 57.46C214.87 59.76 217.9 60.93 222.09 60.93H240.39L236.3 75.8H218.33H218.34ZM372.13 75.8H353.93L353.96 75.69L368.08 24.44H328.06L324.81 36.35H350L349.97 36.46L346.32 49.75H321.13L317.84 61.67H347.3L343.41 75.81H279.32L279.3 75.77L264.69 51.26L257.95 75.81H239.74L239.77 75.7L257.78 10.31H276L269.21 34.97L295.38 10.31H407.41L403.52 24.45H386.31L372.14 75.81L372.13 75.8ZM494.59 37.34H451.55L448.37 48.88H491.42L487.53 63.01H444.47L440.93 75.86H396.64L400.53 61.72H443.54L446.72 50.18H403.68L407.57 36.04H450.62L453.8 24.5H410.74L414.62 10.36H458.98L455.44 23.2H498.47L494.58 37.34H494.59Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="510.46" height="86.03" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}
